
import React from 'react';
import Skeleton from './skeletonLoader.styles';

interface SkeletonLoaderProps {
  type?: string;
  width?: string;
  height?: string;
  duration?: number;
  circle?: boolean;
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type,
  width,
  height,
  duration,
  circle,
  count = 1
}) => {
  const renderSkeletons = () => {
    const skeletons = [];

    for (let i = 0; i < count; i++) {
      skeletons.push(
        <Skeleton
          data-testid="skeleton-loader"
          key={i}
          width={width}
          height={height}
          duration={duration}
          circle={circle}
        />
      );
    }

    return skeletons;
  }

  return (
    <div>
      {renderSkeletons()}
    </div>
  );
};

export default SkeletonLoader;
